import {CookiesKeysEnum} from "@/lib/enums/CookiesKeysEnum";

/**
 * Pin an explicit language choice in `NEXT_LOCALE`, with the same attributes
 * next-intl uses for it (path `/`, `SameSite=Lax`, session lifetime).
 *
 * next-intl's `router.replace(..., {locale})` only writes the cookie when the
 * target differs from `useLocale()` — and after a client-side locale switch that
 * context can be stale (see `localelessPath`). Switching es → en then skipped the
 * write, the old `NEXT_LOCALE=es` survived, and the next reload of `/` was
 * redirected straight back to `/es`. Writing it ourselves makes the choice stick.
 */
export function persistLocaleChoice(locale: string) {
    document.cookie = `${CookiesKeysEnum.NEXT_LOCALE}=${locale}; path=/; SameSite=Lax`;
}
